import { apiSmSheet } from '@spo/services/api';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { environment } from '../environments/environment';

export const useSmSheet = (smId: string, offerDate: string) => {
  const contentMediaUrl = environment.contentMediaUrl;
  return useQuery({
    queryKey: ['SmSheet', smId],
    queryFn: async ({ signal }) => {
      if (!signal?.aborted) {
        return apiSmSheet.getSmSheet({
          smId,
          offerDate,
          language: 'EN',
          contentMediaUrl,
        });
      }
    },
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: !!smId,
  });
};
